import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ActiveUserInfo, AppState, initialState } from './appState';

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setActiveUserInfo: (state: AppState, action: PayloadAction<ActiveUserInfo>) => {
            state.activeUserInfo = action.payload;
        },
        clearActiveUserInfo: (state: AppState) => {
            state.activeUserInfo = undefined;
        },
        setIsServiceUnavailable: (state: AppState, action: PayloadAction<boolean>) => {
            state.isServiceUnavailable = action.payload;
        },
        dismissDisclaimer: (state: AppState) => {
            state.disclaimerDismissed = true;
        },
    },
});

export const { setActiveUserInfo, clearActiveUserInfo, setIsServiceUnavailable, dismissDisclaimer } = appSlice.actions;

export default appSlice.reducer;
